import React from 'react';
import { useMutation } from 'react-query';

import { deleteCommentMedia } from './services/deleteCommentMedia';

type Params = {
  mediaId: string;
};

export function useDeleteCommentMedia() {
  const mutation = useMutation((mediaId: string) =>
    deleteCommentMedia(mediaId),
  );

  const mutateAsync = React.useCallback(
    async (params: Params) => {
      await mutation.mutateAsync(params.mediaId);
    },
    [mutation],
  );

  return { ...mutation, mutateAsync };
}
